import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./types.js";
import { msg } from "@lit/localize";
//#region src/validators.ts
var validators_exports = /* @__PURE__ */ __exportAll({
	emailValidator: () => emailValidator,
	numberValidator: () => numberValidator,
	phoneValidator: () => phoneValidator,
	requiredCheckedValidator: () => requiredCheckedValidator,
	requiredRangeValidator: () => requiredRangeValidator,
	requiredSelectValidator: () => requiredSelectValidator,
	requiredValidator: () => requiredValidator,
	urlValidator: () => urlValidator,
	vatValidator: () => vatValidator
});
var requiredValidator = (value) => {
	return value === null || value === void 0 || value === "" ? msg("Eingabe erforderlich", { id: "pd.form.field.required" }) : null;
};
var requiredSelectValidator = (value) => {
	return value === "UNDEF" ? msg("Eingabe erforderlich", { id: "pd.form.field.selectRequired" }) : null;
};
var requiredCheckedValidator = (value) => {
	return value === "false" ? msg("Eingabe erforderlich", { id: "pd.form.field.checkRequired" }) : null;
};
var requiredRangeValidator = (value) => {
	return value === "0" ? msg("Eingabe erforderlich", { id: "pd.form.field.rangeRequired" }) : null;
};
var emailValidator = (value) => {
	if (!value) return null;
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? null : msg("Format mail@test.de verwenden", { id: "pd.form.field.invalid.mail" });
};
var phoneValidator = (value) => {
	if (!value) return null;
	return /^\+?[0-9 ]{7,15}$/.test(value) ? null : msg("Format +49123 123456 verwenden", { id: "pd.form.field.invalid.phone" });
};
var vatValidator = (value) => {
	if (!value) return null;
	return /^[A-Z]{2}[0-9]{8,12}$/.test(value) ? null : msg("Format DE0123456789 verwenden", { id: "pd.form.field.invalid.vat" });
};
var urlValidator = (value) => {
	if (!value) return null;
	const host = value.replace(/^https?:\/\//, "");
	if (!host) return null;
	return /^[^\s/]+\.[^\s/]+/.test(host) ? null : msg("Gültige URL eingeben (z.\xA0B. example.com)", { id: "pd.form.field.invalid.url" });
};
var numberValidator = (value) => {
	if (!value) return null;
	const normalized = typeof value === "string" ? value.replaceAll(",", ".") : value;
	return !isNaN(parseFloat(normalized)) && isFinite(normalized) ? null : msg("Nur Zahlen erlaubt", { id: "pd.form.field.invalid.number" });
};
//#endregion
export { emailValidator, numberValidator, phoneValidator, requiredCheckedValidator, requiredRangeValidator, requiredSelectValidator, requiredValidator, urlValidator, validators_exports, vatValidator };
